<template>

<div class="container">
<h2>▶請先登入</h2>
<form class="center-box-inner login-form">
  <div class="form-group center-box-inner border p-4 rounded border-secondary">
    <VeeForm ref="form">

          <div class="psw-note mt-4"><strong class="text-secondary">提示：請輸入OpenID的email帳號</strong></div>
          <Vee class="mb-3" rules="required" v-slot="{errors}">
            <div class="input-group">
              <div class="input-group-prepend">
                <label class="input-group-text width-s justify-content-end required" for="contact_email">OpenID帳號</label>
              </div>
              <input class="form-control" id="contact_email" v-model="email" type="email" placeholder="聯絡人的email"/>
            </div>
            <div class="input-err-msg">{{errors[0]}}</div>
          </Vee>

          <div class="psw-note mt-4"><strong class="text-secondary">無法登錄可按下方忘記密碼重新發送﹔</strong></div>
          <Vee class="mb-3" rules="required" v-slot="{errors}">
            <div class="input-group">
              <div class="input-group-prepend"><span class="pwunput input-group-text width-s justify-content-end required" for="psw">密碼<span class="text-primary"></span></span></div>
              <input class="form-control pwinput" id="psw" @input="handleInput" v-model="psw" :type="showPassword ? 'text' : 'password'" v-bind:placeholder="placeholder" autocomplete="off"/>
              <div class="input-group-append">
                <div class="input-group-text" :class="{'cursor-pointer':showPointer}" @click="showPassword = !showPassword" @mouseout="showPointer = false" @mouseover="showPointer = true">
                  <b-icon-eye v-if="! showPassword"></b-icon-eye>
                  <b-icon-eye-fill v-if="showPassword"></b-icon-eye-fill>
                </div>
              </div>
            </div>
            <div class="input-err-msg">{{errors[0]}}</div>

          </Vee>



          <div class="form-group form-check">
            <div class="row">
            <div class="col-sm mt-4">
              <input class="form-check-input" id="exampleCheck1" type="checkbox" v-model="isSaveEmail" />
              <label class="form-check-label" >記住我</label>
            </div>
            <div class="col-sm">
          </div>
          </div>

        </div>
        <div class="form-group">
            <b-row align-h="between">
              <b-col cols="auto">
                <button class="btn btn-outline-dark btn-lg " type="submit" @click="onForgotPW">忘記密碼</button>
              </b-col>

              <b-col cols="auto">
                <button class="btn btn-primary btn-lg text-light" type="submit" @click="onLogin">登入</button>
              </b-col>




          </b-row>
        </div>

    </VeeForm>
  </div>
</form>
</div>


        <!-- <div class="form-group">
          <label for="exampleInputEmail1">Email</label>
          <input class="form-control" id="exampleInputEmail1" type="email" aria-describedby="emailHelp" v-model="email" />
          <small class="form-text text-muted" id="emailHelp">提示：申請時填寫的email帳號</small>
        </div>
        <div class="form-group">
          <div class="input-group-prepend"><span class="pwunput input-group-text width-s justify-content-end required" for="psw">密碼： <span class="text-primary">( 請輸入【申請進度查詢】用密碼 )</span></span></div>
         <input class="form-control" id="exampleInputPassword1" type="password" v-model="psw" />
          <input class="form-control pwinput" id="psw" @input="handleInput" v-model="psw" :type="showPassword ? 'text' : 'password'" v-bind:placeholder="placeholder" autocomplete="off"/>
          <div class="input-group-append">
            <div class="input-group-text" :class="{'cursor-pointer':showPointer}" @click="showPassword = !showPassword" @mouseout="showPointer = false" @mouseover="showPointer = true">
              <b-icon-eye v-if="! showPassword"></b-icon-eye>
              <b-icon-eye-fill v-if="showPassword"></b-icon-eye-fill>
            </div>
          </div>

        </div> -->


</template>

<script>
import { login, forgotPassword } from '@/api/client/Class'
import { BIconEye, BIconEyeFill } from 'bootstrap-vue'
import { extend } from 'vee-validate'
extend('psw', {
    validate(value) {
      const minLength = 8
      const symbols = '@#$%^&+='
      if (value.length < minLength) return false
      if (
        value.split('').every(e => e === e.toLowerCase()) ||
        value.split('').every(e => e === e.toUpperCase())
      ) return false
      if (!value.split('').find(e  => symbols.includes(e))) return false
      const fullWidthList = value.match(/[\uff00-\uffff]/g)
      if (fullWidthList) return false
      return true
    },
    message: '密碼不符合要求！'
  })
export default {
  components: {
      // FileUploader,
       BIconEye,
       BIconEyeFill
    },
    name: 'PasswordInput',
       props: {
       placeholder: String,
       value: String
    },
  data (){
    return {
      email: '',
      psw: '',
      isSaveEmail: false,
      isPassword: false,
      showPassword: false,
      showPointer: false,

    }
  },
  computed: {
    isLogin () {
     // return this.$route.name === 'UploadData'
    }
  },
  methods: {
    saveUser(data){
      sessionStorage.setItem('user3', JSON.stringify(data))
    },
    handleInput (e) {
        this.$emit('input', this.password)
    },
    async onLogin () {
      try {
        const { data } = await login({
          email: this.email,
          psw: this.psw
        })
        console.log(data)

        if (!data) throw new Error('onLogin')
        const { u_str } = data
        const payload = this.isSaveEmail ? {
          email: this.email,
          u_str
        } : { u_str }

        this.saveUser(payload)
        console.log("登入成功")
        //this.$router.push({ name: 'DataList' })
        this.$router.push({ path: '/activity/results' })

      } catch(err) {
        alert('登入失敗, 請重新確認帳號密碼！')
      }
    },
    async onForgotPW() {
      //let actEmail= await forgotPassword({ email })
      console.log("重送密碼")

      const url = new URL(location.origin + '/forgot_classPW2.html');
      window.open(url.toString(),'_blank', 'width=460, height=300' )


      // try{
      //   const  actEmail   = await forgotPassword({
      //     email: this.email,

      //   })
      //   if(!actEmail) throw new Error('onForgotPW')

      //   console.log(this.email)
      //   console.log(actEmail)
      //   // if(!data) throw new Error('onForgotPW')
      //   // const { u_str } = data
      //   // const payload = this.isSaveEmail ? {
      //   //   email: this.email,
      //   //   u_str
      //   // } : { u_str }
      // } catch(err){
      //   alert('格式錯誤')
      // }

      // if(actEmail.errcode === 0){
      //   alert('已重新寄發密碼到您的信箱')
      // }else{
      //   alert('格式錯誤')
      // }

    }
  },
  mounted(){
    const getUser = this.$route.query.user
    const getPW = this.$route.query.psw
    if(getUser !== null){
      this.email = getUser
    }

    if(getPW !== null){
      this.pw = getPW
    }

    const user = sessionStorage.getItem('user3')
    if(user == null) return
    const { email } = JSON.parse(user)
    if(email) {
      this.email = email
      console.log(this.email)
      //this.$router.push({ name: 'DataList' })
      this.isSaveEmail = true
    }
  }


}
</script>

  <style lang="sass" scoped>
  .login-form
    max-width: 350px
    margin-right: auto
    margin-left: auto
  .new-line
    display: block
    width: 400px
  .input-group
    position: relative
  .form-control
    position: static
  .pos-abs
    position: absolute
  .input-err-msg
    color: red
  .psw-note
    font-size: 12px
    padding: 0 1rem
    margin-top: 0
  input.money-input
    max-width: 150px
  input.else-input
    max-width: 200px
  span.required:before, label.required:before
    content: "*"
    color: red
  </style>





// WEBPACK FOOTER //
// src/views/activity_results/loginNow2.vue